module.exports = __webpack_public_path__ + "static/media/galaxy.0e7c210e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/galaxy.jpg
// module id = 31
// module chunks = 0